// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"tomato_resetButton__ITuPx","circle":"tomato_circle__1cvKN","innerCircle":"tomato_innerCircle__3aOFw","timer":"tomato_timer__AoZLT"};